// --------------------------------------------------------------
// Created On: 2025-04-02
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-07
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./ManualRpmControls.module.scss";
import { BREAKPOINT_EXTRA_EXTRA_LARGE, BREAKPOINT_EXTRA_LARGE, BREAKPOINT_SMALL } from "src/constants/breakpoints";

// Container for the Manual RPM input field within the Monitoring Device Operations section
// of the Remote Operation Panel.
export default function ManualRpmControls(props: Props): Component {
  const [manualRpm, setManualRpm] = useState<string>("");

  // Apply the manual RPM value if it is a valid number.
  function applyManualRpm(rpm: string): void {
    rpm = rpm.trim();
    if (rpm.length === 0) {
      props.onError("Invalid RPM entered.");
      return;
    }
    const rpmNumber = parseInt(rpm, 10);
    if (Number.isNaN(rpmNumber)) {
      props.onError("Entered RPM is not an integer.");
      return;
    } else if (rpmNumber < 0) {
      props.onError("Entered RPM must be a positive number.");
      return;
    }
    props.onChangeSpeed(rpmNumber);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-9 g-0 ps-3">
          <input
            className={`${styles.manualRpm} align-self-center`}
            type="text"
            maxLength={10}
            value={manualRpm}
            onChange={(e) => setManualRpm(e.target.value)}
          />
        </div>
        <div className="col-3 g-0 pe-3">
          <button
            className={`${styles.manualRpmButton} align-self-center btn-primary`}
            type="button"
            disabled={props.loading}
            onClick={() => applyManualRpm(manualRpm)}
          >
            {props.windowDimensionWidth > BREAKPOINT_SMALL &&
            (props.windowDimensionWidth < BREAKPOINT_EXTRA_LARGE ||
              props.windowDimensionWidth > BREAKPOINT_EXTRA_EXTRA_LARGE)
              ? "Set RPM"
              : "RPM"}
          </button>
        </div>
      </div>
    </div>
  );
}

ManualRpmControls.propTypes = {
  loading: PropTypes.bool.isRequired,
  windowDimensionWidth: PropTypes.number.isRequired,
  onChangeSpeed: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

interface Props {
  loading: boolean;
  windowDimensionWidth: number;
  onChangeSpeed: (command: number) => void;
  onError: (error: string) => void;
}
